import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as RadixPopover from '@radix-ui/react-popover';
import styled, { keyframes } from 'styled-components';
const PopoverRoot = ({ children, content, popperProps, withArrow = false, className, sideOffset = 20, ...props }) => {
    return (_jsxs(RadixPopover.Root, { ...props, children: [_jsx(RadixPopover.Trigger, { asChild: true, children: children }), _jsx(RadixPopover.Portal, { children: _jsxs(Content, { className: className, sideOffset: sideOffset, ...popperProps, children: [content, withArrow ? _jsx(Arrow, {}) : undefined] }) })] }));
};
const slideUpAndFade = keyframes `
	from {
		opacity: 0;
		transform: translateY(4px);
	}

	to {
		opacity: 1;
		transform: translateY(0);
	}
`;
const slideRightAndFade = keyframes `
	from {
		opacity: 0;
		transform: translateX(-4px);
	}
	to {
		opacity: 1;
		transform: translateX(0);
	}
`;
const slideDownAndFade = keyframes `
	from {
		opacity: 0;
		transform: translateY(-4px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
`;
const slideLeftAndFade = keyframes `
	from {
		opacity: 0;
		transform: translateX(4px);
	}
	to {
		opacity: 1;
		transform: translateX(0);
	}
`;
const Content = styled(RadixPopover.Content) `
  background: var(--background-3);
  border-radius: 20px;
  box-shadow: ${({ theme }) => theme.shadows[1]};
  overflow: hidden;
  outline: none;
  min-width: var(--radix-popper-anchor-width);

  animation-duration: 400ms;
  animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);

  &[data-side='top'] {
    animation-name: ${slideDownAndFade};
  }
  &[data-side='right'] {
    animation-name: ${slideLeftAndFade};
  }
  &[data-side='bottom'] {
    animation-name: ${slideUpAndFade};
  }
  &[data-side='left'] {
    animation-name: ${slideRightAndFade};
  }
`;
const Arrow = styled(RadixPopover.Arrow) `
  fill: ${({ theme }) => theme.palette.gray[3]};
`;
const Popover = PopoverRoot;
export { Popover };
//# sourceMappingURL=popover.js.map